// extracted by mini-css-extract-plugin
export default {"metaBox":"meta-box_metaBox__x6QEy","title":"meta-box_title__BWoUK","header":"meta-box_header__-4xOn","body":"meta-box_body__Cp2Ak"};